<template>
	<div class="gb-chart-row"
		v-statemachine= "sm_row"
		v-bind:class="classSelectRow"
		v-bind:style="styleChartRow"
	>
		<GBAlertSchedule
			v-for="schedule in alertSchedules"
			v-bind:key="schedule.code"
			v-bind:height="height"
			v-bind:schedule="schedule"
		/>
		<GBGhostSchedule
			v-bind:ghost_schedule="ghost_schedule"
			v-bind:item="item"
			v-bind:parent="parent"
		/>
		<GBBar 
			v-for="schedule in schedules"
			v-bind:key="schedule.code"
			v-bind:schedule="schedule"
			v-bind:parent="item"
			v-bind:isEditable="isEditable"
			v-bind:isParent="isParent"
			v-on:bar-move-start="barMoveStart"
			v-on:bar-stretch-start="barStretchStart"
			v-on:bar-move-break="barMoveBreak"
			v-on:progress-rate-setting="progressRateSetting"
			v-on:request-ghost-schedule="onRequestGhostSchedule"
			ref="bar" />
	</div>
</template>
<script>
import GBBar from './GBBar';
import GBAlertSchedule from './GBAlertSchedule';
import GBGhostSchedule from './GBGhostSchedule';
import ScheduleListRow from '../data/ScheduleListRow';
import Schedule from '../data/Schedule';
import ScheduleTick from '../data/ScheduleTick';
import EventTarget from '../data/EventTarget';
import BarEventTarget from '../data/BarEventTarget';
import ChartRowEventTarget from '../data/ChartRowEventTarget';
import Color from '../data/Color';
import MouseState from '../classes/MouseState';
import MouseStateMachine from '../classes/MouseStateMachine';
import Notification from '../classes/Notification';
import DataSetManager from '../classes/DataSetManager';
import { UNIT_WIDTH } from '../data/Const';
import _ from 'lodash';
import Util from '../classes/Util';
import ProjectPinned from '../data/ProjectPinned';

const strftime = require('strftime');
const findChartRow = (elem) => {
	let found = null;

	if (elem.classList.contains('gb-chart-row')) {
		found = elem;
	} else {
		found = elem.closest('.gb-chart-row');
	}

	return found;
}
export default {
	name: 'GBChartRow',
	components: {
		GBBar,
		GBAlertSchedule,
		GBGhostSchedule,
	},
	props: [
		"item",
		"parent",
		"isEditable",
		"code",
		"ghost_schedule",
	],
	data () {
		const state_nop = new MouseState({});
		return {
			state_nop: state_nop,
			sm_row: new MouseStateMachine(state_nop),
			mouse_position: {
				layer: {
					x: 0,
				},
				page: {
					x: 0,
				},
			},
			dataset_manager: this.$store.getters.datasetManager,
		}
	},
	mounted: function() {
		this.sm_row.next(this.defaultStateRow());
	},
	methods: {
		barMoveStart: function(e) {
			this.$emit('bar-move-start', e);
		},
		barStretchStart: function(e) {
			this.$emit('bar-stretch-start', e);
		},
		barMoveBreak: function() {
			this.$emit('bar-move-break');
		},
		createNewSchedule: function() {
			let unit_ticks = this.$store.getters.unitTicks;
			let baseDate = this.$store.getters.calendarBaseDate;
			let begin = new ScheduleTick({code: strftime('%Y%m%d', baseDate) + ScheduleTick.TERM.AM});
			let ticks = Math.floor(this.mouse_position.layer.x / UNIT_WIDTH.TICK) * unit_ticks;
			let progress_rate = 0;
			begin.addTick(ticks);
			let project_code = this.item.code;
			let member_code;
			
			if (this.item.isMember) {
				project_code = this.parent.code;
				member_code = this.item.code;	
			}
			
			let color_type = this.item.isProject ? Color.RELATION_TYPE.PROJECT : Color.RELATION_TYPE.MEMBER;

			return new Schedule({
				project_code: project_code,
				member_code: member_code,
				begin: begin,
				end: begin.clone().addTick(unit_ticks - 1),
				progress_rate: progress_rate,
				color_code: this.$store.getters.defauleColorCode(color_type),
			});
		},
		progressRateSetting: function(e) {
			this.$emit("progress-rate-setting", e);
		},
		onRequestGhostSchedule: function(e) {
			this.$emit("request-ghost-schedule", e);
		},
		defaultStateRow: function() {
			if (!this.isEditable)
				return this.state_nop;

			const state_default = new MouseState({
				down: (e) => {
					let obj = e.targetTouches ? e.targetTouches[0] : e;
					let touchX = obj.pageX;
					let row = findChartRow(obj.target);
					if (row === null)
						return;
					let clientRect = row.getBoundingClientRect();
					let positionX = clientRect.left + window.pageXOffset;
					let x = touchX - positionX;
				
					this.mouse_position.layer.x = x;
					this.mouse_position.page.x = touchX;
				},
				move: _.debounce((e) => {
					let obj = e.targetTouches && e.targetTouches.length > 0 ? e.targetTouches[0] : e;
					if(obj.pageX === undefined)
						return;
					
					// ios13のバグでtargetTouchesが空になった場合、clientX/Yが取得できなくなる
					// その場合、pageX/Yを代用する
					// clientX/Y=pageX/Yの時は問題ないが、ずれると縦移動がおかしな動きをする
					let x = obj.clientX ? obj.clientX : obj.pageX;
					let y = obj.clientY ? obj.clientY : obj.pageY;
					let target_elm = findChartRow(document.elementFromPoint(x, y));
					if (target_elm === null)
						return;

					let target = null;
					if (this.item.isProject) {
						let match = this.$parent.$parent.$children.filter((content) => {
							let row = content.$children[0];
							return row.$el === target_elm;
						})[0];
						if (match !== undefined)
							target = match.$children[0];
					} else if (this.item.isMember) {
						let match = this.$parent.$children.filter((row) => {
							return row.$el === target_elm;
						})[0];
						if (match !== undefined)
							target = match;
					} else {
						return;
					}
					if (target === null)
						return;
		
					this.$emit('chart-row-mouse-move', new ChartRowEventTarget({
						target: target,
						target_type: EventTarget.TARGET_TYPE.CHART_ROW_MOUSE_MOVE,
					}));
				}, 1),
				longpress: (e) => {
					e.stopPropagation();
					this.dataset_manager.setBeforeDataset();
					let s = this.createNewSchedule();
					this.$store.dispatch('addSchedule', {
						schedule: s,
					});
					this.updateDataSet();
					this.$nextTick(() => {
						let bar = this.$refs.bar;
						let vc = bar[bar.length - 1];
						this.$emit('hscroll-stop', e);
						this.$emit('bar-stretch-start', new BarEventTarget({
							target: vc,
							target_type: EventTarget.TARGET_TYPE.SCHEDULE_STRECH_END,
							x: this.mouse_position.page.x,
						}));
					});
				},
				up: () => {
					this.$store.dispatch('endExclusive');
				},
			});
			
			return state_default;
		},
		updateDataSet: function() {
			const onFail = async (err) => {
				const callback = {
					401: () => {
						this.logout();
					},
				};
				Util.updateFail(this.$store, err.response, callback);
				
				this.fetchData();
			};
			const onTokenFail = () => {
				this.logout();
			};
			this.dataset_manager.setAfterDataset();
			this.dataset_manager.sync(null, onFail, onTokenFail);
		},
		fetchData: async function() {
			let access_token = await DataSetManager.confirmAccessToken(this.$store);
			await this.dataset_manager.fetch(access_token)
				.then((data) => {
					this.$store.commit('createData', data);
				})
				.catch(async (e) => {
					let notification = null;
					switch(e.response.status) {
					case 400:
						notification = Notification.error('リクエストに失敗しました', 'notificationCreateData');
						break;
					case 401:
						notification = Notification.error('もう一度ログインしてください', 'notificationCreateData');
						this.logout();
						break;
					case 403:
						notification = Notification.error('権限がありません', 'notificationCreateData');
						this.logout();
						break;
					case 404:
						notification = Notification.error('契約者情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 500:
						notification = Notification.error('情報の取得に失敗しました', 'notificationCreateData');
						break;
					case 504:
						notification = Notification.error('タイムアウトしました', 'notificationCreateData');
						break;
					default :
						notification = Notification.error('通信に失敗しました', 'notificationCreateData');
						break;
					}
					this.$store.commit('addNotification', notification);
				});
		},
		logout: function() {
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
	},
	computed: {
		height: function() {
			let pinned = this.getProjectPinned;
			if (this.item.isProject) {
				let h = 49;
				let cnt = 0;
				
				if (pinned[ProjectPinned.TYPE.CLASS][ProjectPinned.PINNED_ID_CLASS] && !this.isWorkerRole) {
					cnt ++;
				}
				this.$store.getters.additionalInfo.forEach(add => {
					if (pinned['2'][add.code]) {
						cnt ++;
					}
				});
				
				if (cnt > 0) {
					cnt -= 1;
				}
				h += (16 * cnt);
				
				return h;
			} else {
				return 49;
			}
		},
		isParent: function() {
			return this.parent === undefined;
		},
		schedules: function() {
			if (this.$store.getters.isDisplayListTypeMember) {
				if(this.isParent) {
					let filterd = this.$store.getters.filteringSchedules(this.item.schedules, this.item.children);
					let member_schedule = ScheduleListRow.createMergedSchedule(filterd);
					return member_schedule;
				} else {
					return this.$store.getters.filteringSchedules(this.item.schedules, null);
				}
			} else {
				if(!this.isParent)
					return this.$store.getters.filteringSchedules(this.item.schedules, null);
			}
			return this.item.schedules;
		},
		alertSchedules: function() {
			let alerts;
			if (this.$store.getters.isDisplayListTypeMember) {
				if (this.item.item_type == ScheduleListRow.ITEM_TYPE.MEMBER) {
					alerts = this.item.createOverlapSchedules(this.item.schedules);
				} else {
					alerts = this.parent.createOverlapSchedules(this.parent.schedules);
				}
			} else {
				if (this.isParent) {
					alerts = this.item.createOverChildrenSchedules();
				} else {
					let all = new Array();
					this.$store.getters.projectList.forEach(p => {
						p.members.filter(m => { return m.code === this.item.code }).forEach(m => {
							m.schedules.forEach(s => {
								all.push(s);
							});
						});
					});
					alerts = ScheduleListRow.createOverlapSchedules(all, this.item.schedules);
				}
			}

			if (alerts)
				return alerts;
			return new Array();
		},
		styleChartRow: function() {
			return {
				height: this.height + 'px',
			};
		},
		classSelectRow: function() {
			if (this.ghost_schedule === undefined || this.ghost_schedule === null)
				return '';
			
			let classes = new Array();
			
			if (this.item.item_type === ScheduleListRow.ITEM_TYPE.PROJECT && !this.ghost_schedule.member_code) {
				if (this.ghost_schedule.project_code === this.item.code && this.parent !== null)
					classes.push('select-row');
			} else if (this.item.item_type === ScheduleListRow.ITEM_TYPE.MEMBER && this.ghost_schedule.member_code) {
				if (this.ghost_schedule.member_code === this.item.code && this.ghost_schedule.project_code === this.parent.code)
					classes.push('select-row', 'select-row-member');
			}

			return classes;
		},
		getProjectPinned: function() {
			let pinned = this.$store.getters.projectPinned(this.item.code);
			
			if (pinned === undefined) {
				pinned = this.$store.getters.projectPinned('default');
			}
			return pinned;
		},
		isWorkerRole: function() {
			return this.$store.getters.isWorkerRole;
		},
	},
	watch: {
		isEditable: function() {
			this.sm_row.next(this.defaultStateRow());
		},
	},
}
</script>
<style>
	.gb-chart-row {
		position: relative;
		width: 100%;
		color: white;
		padding: 0;
	}
	.gb-chart-row.select-row {
		background-color: rgba(0, 0, 0, .1);
	}
	.gb-chart-row.select-row-member {
		border-top: solid 1px white;
	}
</style>
